<!-- Loading bar -->
<fuse-loading-bar />

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card z-49 flex-0 relative flex h-16 w-full items-center px-4 shadow md:px-6">
        <!-- Back button -->
        <button
            mat-icon-button
            (click)="goBack()"
            class="mr-2"
            matTooltip="Zurück zu Prompts"
            aria-label="Zurück zu Prompts">
            <mat-icon svgIcon="mat_outline:arrow_back" />
        </button>

        <!-- Logo -->
        <div class="mr-4 flex items-center">
            <img class="flex h-8" src="images/logo/logo-text-on-dark.svg" alt="Logo" />
        </div>

        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block" />
            <help-menu />
            <user />
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <router-outlet />
    </div>

    <!-- Footer -->
    <div
        class="bg-card z-49 flex-0 relative flex h-14 w-full items-center justify-start border-t px-4 md:px-6">
        <span class="text-secondary font-medium">AI Lotse &copy; {{ currentYear }}</span>
    </div>
</div>
